import React from 'react';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { debugCreate } from '../../../state/order/actions';
import { insertData, getNewOrderJSON } from './newOrderJSON';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '90%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text: {
    marginBottom: 10,
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
}));

export default function Debugger(props) {
  const [json, setJSON] = React.useState(getNewOrderJSON() || '');
  const classes = useStyles();
  const dispatch = useDispatch();

  const action = () => {
    const _json = insertData(json);
    dispatch(debugCreate(_json));
  }

  return (
    <div className={classes.root}>
      <Typography variant="caption" className={classes.text}>Criar novo pedido</Typography>
      <TextField
        variant="outlined"
        label="JSON"
        margin="dense"
        value={json}
        onChange={(e) => setJSON(e.target.value)}
        rows={12}
        fullWidth
        multiline
      />
      <div className={classes.action}>
        <Button color="primary" variant="contained" onClick={action}>Criar</Button>
      </div>
    </div>
  );
}